// src/icons/ReadinessOutline.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function ReadinessOutline({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 24,
    viewBox: "0 0 25 24",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        d: "M13.4263 6.00781C13.4263 3.6606 15.3291 1.75781 17.6763 1.75781H22.9263V3.00781C22.9263 5.35502 21.0235 7.25781 18.6763 7.25781H16.6763C16.2621 7.25781 15.9263 7.5936 15.9263 8.00781C15.9263 8.42203 16.2621 8.75781 16.6763 8.75781H18.6763C21.8519 8.75781 24.4263 6.18345 24.4263 3.00781V1.00781C24.4263 0.593599 24.0905 0.257812 23.6763 0.257812H17.6763C14.5006 0.257812 11.9263 2.83217 11.9263 6.00781V11.1348C10.8747 9.98149 9.35999 9.25781 7.67627 9.25781H1.67627C1.26206 9.25781 0.92627 9.5936 0.92627 10.0078V12.0078C0.92627 15.1834 3.50063 17.7578 6.67627 17.7578H11.9263V23.0078C11.9263 23.422 12.2621 23.7578 12.6763 23.7578C13.0905 23.7578 13.4263 23.422 13.4263 23.0078V6.00781ZM11.9263 16.2578H6.67627C4.32906 16.2578 2.42627 14.355 2.42627 12.0078V10.7578H7.67627C10.0235 10.7578 11.9263 12.6606 11.9263 15.0078V16.2578Z",
        fill: "currentColor"
      })
    ]
  });
}
export {
  ReadinessOutline
};
//# sourceMappingURL=ReadinessOutline.mjs.map